module.exports = __webpack_public_path__ + "media/categories/6008-5c1e630a.svg";